export class OneTrustInterface {
  constructor(config) {
    this.config = {
      ...config,
    };

    this.initialized = false;

    window.addEventListener('otSDKReady', () => {
      if (!this.initialized) {
        this.init();
      }
    });
  }

  init() {
    const { thirdParty } = this.config;

    OneTrust.OnConsentChanged((e) => {
      if (!window.OneTrustPermissionGiven) {
        if (e.detail?.includes('C0003')) {
          window.OneTrustPermissionGiven = true;
          thirdParty?.onCookiesAccepted();
        } else {
          thirdParty?.onPermissionRevoked();
        }
      }
    });

    window.addEventListener('thirdparty.accepted', () => {
      if (!window.OneTrustPermissionGiven) {
        window.OneTrustPermissionGiven = true;
        OneTrust.UpdateConsent('Category', 'C0003:1');
      }
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get('kioskMode') === 'true') {
      OneTrust.AllowAll();
    }

    this.initialized = true;
  }
}
